/*
  Regalo automático: una Mini Colección Sorpresa por compra (2026-08-20).

  Cómo se comporta el descuento MINI-COLECCIONES, medido sobre la tienda con un
  fetch limpio (sin este script encima, que antes falseaba la medición):

    1 perfume  + 1 mini colección   → 1 gratis
    1 perfume  + 2 mini colecciones → 1 gratis, 1 cobrada ($12.990)
    2 perfumes + 3 mini colecciones → 2 gratis, 1 cobrada ($12.990)

  O sea: quedan gratis tantas mini colecciones como unidades de producto haya, y
  el excedente se cobra. No se cae el descuento completo.

  De ahí salen las reglas:

    1. El regalo es UNO por compra, no uno por producto, y no cambia aunque el
       cliente lleve más productos: las demás mini colecciones las agrega él.
    2. Nunca se toca una mini colección que agregó el cliente. Puede comprar las
       que quiera además del regalo; solo se administra la línea propia.
    3. Si el cliente saca el regalo a mano, no se le vuelve a ofrecer en la visita.
    4. Sin productos, se retira el regalo.

  Con dos perfumes, la segunda que agregue el cliente le sale gratis igual (el
  descuento cubre una por producto). Con uno solo, la segunda se le cobra: es una
  compra que decidió él, y el regalo sigue en $0.

  La línea propia se distingue por la propiedad visible "Regalo: Incluido con tu
  compra" —que además le avisa al cliente que no la agregó él y que puede sacarla.
  Sin esa marca las dos serían indistinguibles y el script terminaba borrando la
  que el cliente había comprado.

  Los datos (variante y handles de la colección) los entrega el Liquid de
  snippets/regalo-automatico.liquid, porque /cart.js no expone la colección de cada
  línea.
*/
(function () {
  var nodo = document.getElementById('ins-regalo-datos');
  if (!nodo) return;

  var cfg;
  try {
    cfg = JSON.parse(nodo.textContent);
  } catch (e) {
    return;
  }
  if (!cfg.varianteRegalo) return;

  // La lista de handles puede llegar corta o vacía si la colección deja de listar
  // sus productos en el admin. El handle del regalo se agrega siempre: sin él, su
  // propia línea se contaría como un producto más y el script pediría otro regalo
  // sin parar. Vacía del todo no se sigue, porque no habría con qué distinguir.
  var HANDLES = Array.isArray(cfg.handlesRegalo) ? cfg.handlesRegalo.slice() : [];
  if (cfg.handleRegalo && HANDLES.indexOf(cfg.handleRegalo) === -1) HANDLES.push(cfg.handleRegalo);
  if (!HANDLES.length) return;

  var ETIQUETA = cfg.etiquetaRegalo || 'Regalo';
  var TEXTO = cfg.textoRegalo || 'Incluido con tu compra';

  var ESTADO = 'insRegaloEstadoPrevio';
  var DESCARTADO = 'insRegaloDescartado';
  var fetchOriginal = window.fetch;
  var operando = false; // evita que nuestras propias llamadas se reevalúen en bucle

  function leer(clave) {
    try {
      return sessionStorage.getItem(clave);
    } catch (e) {
      return null;
    }
  }

  function guardar(clave, valor) {
    try {
      sessionStorage.setItem(clave, valor);
    } catch (e) {}
  }

  function olvidar(clave) {
    try {
      sessionStorage.removeItem(clave);
    } catch (e) {}
  }

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // La marca que dejamos al agregar. Es lo único que separa el regalo de una mini
  // colección que el cliente eligió y quiere pagar.
  function esNuestro(linea) {
    return !!(linea.properties && linea.properties[ETIQUETA] === TEXTO);
  }

  function clasificar(carrito) {
    var lineasNuestras = [];
    var nuestras = 0;
    var compradas = 0;
    var otros = 0;
    (carrito.items || []).forEach(function (linea) {
      if (HANDLES.indexOf(linea.handle) === -1) {
        otros += linea.quantity;
      } else if (esNuestro(linea)) {
        lineasNuestras.push({ key: linea.key, cantidad: linea.quantity });
        nuestras += linea.quantity;
      } else {
        compradas += linea.quantity;
      }
    });
    return { nuestras: nuestras, compradas: compradas, otros: otros, lineas: lineasNuestras };
  }

  function seccionesAPedir() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }

  // El estado "vacío" no vive dentro del cajón sino en el elemento que lo envuelve,
  // así que reemplazar el contenido no basta: hay que marcarlo aparte. Sin esto, al
  // retirar el último regalo el carrito quedaba vacío pero sin su diseño de vacío.
  function sincronizarVacio(cantidad) {
    var vacio = cantidad === 0;
    var envoltura = document.querySelector('cart-drawer');
    if (envoltura) envoltura.classList.toggle('is-empty', vacio);
    var listado = document.querySelector('cart-drawer-items');
    if (listado) listado.classList.toggle('is-empty', vacio);
    var pieCarrito = document.getElementById('main-cart-footer');
    if (pieCarrito) pieCarrito.classList.toggle('is-empty', vacio);
  }

  // Se redibujan las secciones sin abrir el carrito lateral: renderContents() de
  // Dawn lo abriría, y el regalo entra sin que el cliente lo haya pedido.
  function refrescar(respuesta) {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    if (!respuesta || !respuesta.sections) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.getSectionInnerHTML) return;

    var contenedor = document.getElementById('CartDrawer');
    if (contenedor && respuesta.sections['cart-drawer']) {
      contenedor.innerHTML = drawer.getSectionInnerHTML(respuesta.sections['cart-drawer'], '#CartDrawer');
    }
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && respuesta.sections['cart-icon-bubble']) {
      burbuja.innerHTML = drawer.getSectionInnerHTML(respuesta.sections['cart-icon-bubble'], '.shopify-section');
    }

    // Va después del reemplazo, para leer los elementos recién puestos. add.js no
    // devuelve item_count, pero tras agregar el carrito nunca queda vacío.
    sincronizarVacio(typeof respuesta.item_count === 'number' ? respuesta.item_count : 1);
  }

  function pedir(ruta, cuerpo, estadoEsperado) {
    operando = true;
    cuerpo.sections = seccionesAPedir();
    cuerpo.sections_url = window.location.pathname;
    return fetchOriginal(raiz() + ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (respuesta) {
        if (respuesta.status) return;
        // Se anota el estado que dejamos nosotros. Sin esto, la próxima
        // evaluación compara contra el estado anterior a nuestro propio cambio y
        // confunde un retiro automático con uno hecho por el cliente.
        if (estadoEsperado) guardar(ESTADO, JSON.stringify(estadoEsperado));
        refrescar(respuesta);
      })
      .catch(function () {})
      .then(function () {
        operando = false;
      });
  }

  function agregarRegalo(estadoEsperado) {
    var propiedades = {};
    propiedades[ETIQUETA] = TEXTO;
    return pedir(
      'cart/add.js',
      { items: [{ id: cfg.varianteRegalo, quantity: 1, properties: propiedades }] },
      estadoEsperado
    );
  }

  // Solo recibe líneas propias, así que nunca puede recortar una compra del cliente.
  function recortarRegalo(lineas, objetivo, estadoEsperado) {
    var updates = {};
    var restante = objetivo;
    lineas.forEach(function (linea) {
      var dejar = Math.max(0, Math.min(linea.cantidad, restante));
      restante -= dejar;
      if (dejar !== linea.cantidad) updates[linea.key] = dejar;
    });
    if (!Object.keys(updates).length) return;
    return pedir('cart/update.js', { updates: updates }, estadoEsperado);
  }

  function evaluar() {
    if (operando) return;

    fetchOriginal(raiz() + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (carrito) {
        var ahora = clasificar(carrito);

        var antes = null;
        try {
          antes = JSON.parse(leer(ESTADO) || 'null');
        } catch (e) {}

        var resumen = { nuestras: ahora.nuestras, compradas: ahora.compradas, otros: ahora.otros };

        // Carrito vacío: se empieza de nuevo, incluido el descarte que hubiera hecho.
        if (!ahora.nuestras && !ahora.compradas && !ahora.otros) {
          olvidar(DESCARTADO);
          guardar(ESTADO, JSON.stringify(resumen));
          return;
        }

        // Sacó el regalo sin sacar productos ni agregar mini colecciones suyas:
        // fue decisión suya, no se le insiste.
        if (
          antes &&
          ahora.nuestras < antes.nuestras &&
          ahora.otros >= antes.otros &&
          ahora.compradas <= antes.compradas
        ) {
          guardar(DESCARTADO, '1');
        }
        guardar(ESTADO, JSON.stringify(resumen));

        // Una sola, siempre la misma, mientras haya algún producto. Lo que el
        // cliente sume por su cuenta no la desplaza.
        var objetivo = ahora.otros > 0 && !leer(DESCARTADO) ? 1 : 0;

        var esperado = { nuestras: objetivo, compradas: ahora.compradas, otros: ahora.otros };
        if (ahora.nuestras > objetivo) {
          recortarRegalo(ahora.lineas, objetivo, esperado);
          return;
        }
        if (ahora.nuestras < objetivo) {
          agregarRegalo(esperado);
        }
      })
      .catch(function () {});
  }

  // El tema muta el carrito por fetch; se escucha ahí en vez de depender de los
  // eventos internos de Dawn, que no están expuestos fuera de sus módulos.
  window.fetch = function () {
    var destino = arguments[0];
    var url = String((destino && destino.url) || destino || '');
    var promesa = fetchOriginal.apply(this, arguments);
    if (!operando && /\/cart\/(add|change|update|clear)/.test(url)) {
      promesa
        .then(function () {
          setTimeout(evaluar, 300);
        })
        .catch(function () {});
    }
    return promesa;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', evaluar);
  else evaluar();
})();
